<template>
  <div class="default-dashboard full-height">
    <transition class="full-height">
      <keep-alive :include="$route.meta.include">
        <router-view />
      </keep-alive>
    </transition>

    <van-tabbar
      safe-area-inset-bottom
      v-if="isYlslh5"
    >
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <van-col
          v-for="(tab,index) in tabbarList"
          :key="tab.link"
          :span="tabbarList.length == 3 ? 8 : 12"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>

    <van-tabbar
      class="shadow"
      v-if="!isXlminiprogram && !isYlslh5 && dashboardshow && Object.keys(tabbarList).length"

    >
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <van-col
          v-for="tab in tabbarList"
          :key="tab.link"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>
  </div>
</template>

<script>
import home from 'Components/Dynamic/default/images/navbar/home.png'
import home1 from 'Components/Dynamic/default/images/navbar/home1.png'
import user from 'Components/Dynamic/default/images/navbar/user.png'
import user1 from 'Components/Dynamic/default/images/navbar/user1.png'
import approval from 'Components/Dynamic/default/images/navbar/approval.png'
import approval1 from 'Components/Dynamic/default/images/navbar/approval1.png'
import triplist from 'Components/Dynamic/default/images/navbar/triplist.png'
import message from 'Components/Dynamic/default/images/navbar/message.png'
import message1 from 'Components/Dynamic/default/images/navbar/message1.png'
import count from 'Components/Dynamic/default/images/navbar/count.png'
import count1 from 'Components/Dynamic/default/images/navbar/count1.png'
import allorders from 'Components/Dynamic/default/images/navbar/allorder.png'
import allorders1 from 'Components/Dynamic/default/images/navbar/allorder1.png'

import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'
import { Image as VanImage, Badge ,Tabbar} from 'vant'
import defaultMixin from '@/business/mixins/default'
import { isGat } from 'Utils/gattools'
import {queryVipParameter} from 'Utils/publicApi'
import { APP_FROM } from 'Config/index'
import thirdLogin from "@/business/mixins/thirdLogin";
import {AUTH_STATUS_KEY} from "Utils/tools";

export default {
  name: 'Dashboard',
  mixins:[defaultMixin, thirdLogin],
  components:{
    [VanImage.name]: VanImage,
    [Badge.name]: Badge,
    [Tabbar.name]: Tabbar,
  },
  data () {
    return {
      hashAddr: '/home',
      taberr:[],
      dashboardshow:true,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      badgeDotCount: 'badgeDotCount'
    }),
    tabbarList() {
      let obj = []
      if(localget('notlogGAT')=='关爱通'){//关爱通环境
        obj=[
          {
            link: '/home',
            title: 'A003',//首页
            count:'',
            normalImg: home,
            activeImg: home1
          },
          {
            link: '/allOrder?findType=1',
            title: '我的订单',//我的
            otherLink:'/allOrder',
            count: '',
            normalImg: message,
            activeImg: message1,
          },
          {
            link: '/userCenter',
            title: 'A007',//我的
            count:'',
            normalImg: user,
            activeImg: user1,
          }
        ]
        if(this.userInfo.empInfo && this.userInfo.vipCorp){ //登陆状态
          if (this.$store.state.app.navigationbar && this.$store.state.app.navigationbar.length > 0) { //根据后台配置隐藏消息，待办，我的
            obj = obj.filter((item) => !this.$store.state.app.navigationbar.includes(item.title));
          }
        }
        return obj
      }
      if (this.isYlslh5){
        obj=[
          {
            link: '/tk/tkQuery',
            title: 'A003',//首页
            count:'',
            normalImg: home,
            activeImg: home1
          },
          {
            link: '/statistical',
            title: '统计', //统计
            count: '',
            normalImg: count,
            activeImg: count1
          },
          {
            link: '/allOrder?findType=1',
            otherLink:'/allOrder',
            title: 'A104',//我的订单
            count:'',
            normalImg: allorders,
            activeImg: allorders1,
          }
        ]
        if (!(this.userInfo.empInfo.travelStats && this.userInfo.empInfo.travelStats == 1)){
          obj.splice(1,1)
        }
        return obj
      }else {
        obj=[
          {
            link: '/home',
            title: 'A003',//首页
            count:'',
            normalImg: home,
            activeImg: home1
          },
          {
            link: '/userCenter/message', //message
            otherLink: '/noticeList',
            title: '消息',
            count: this.badgeDotCount ? this.badgeDotCount.message:'',
            normalImg: message,
            activeImg: message1
          },
          {
            link: '/tripList',
            title: '出差',
            count:'',
            normalImg: triplist,
            activeImg: triplist
          },
          {
            link: '/approvalList',
            title: '待办',
            count: this.badgeDotCount.topay ? this.badgeDotCount.topay:'',
            normalImg: approval,
            activeImg: approval1
          },
          {
            link: '/userCenter',
            title: 'A007',//我的
            count:'',
            normalImg: user,
            activeImg: user1,
          }
        ]
      }
      if(this.userInfo.empInfo && this.userInfo.vipCorp){ //登陆状态
        if (this.$store.state.app.navigationbar && this.$store.state.app.navigationbar.length > 0) { //根据后台配置隐藏消息，待办，我的
          obj = obj.filter((item) => !this.$store.state.app.navigationbar.includes(item.title));
        }
      }

      let AutoLogin= JSON.parse(localStorage.getItem('AutoLogin'))
      if ( AutoLogin!= null && AutoLogin.compId && (AutoLogin.compId == '84738d21f1904878873161fc4b88ecc8' || AutoLogin.compId == 'e44549fab7184ca392610ae516ec2857')) {//判断智通商户
        if (AutoLogin.corpId == '06a1ff73a3ec4202a607c7af124d81d8' || AutoLogin.corpId == 'acdc56476700470384447a675b0f9c84') {//判断智通企业
          if(this.userInfo.empInfo){
            obj.push(
              {
                link: '/allOrder?findType=1',
                title: '我的订单',//我的
                otherLink:'/allOrder',
                count: '',
                normalImg: message,
                activeImg: message1,
              },
            )
          }

        }
      }
      if(localget('loginType') == APP_FROM.tusu_123) {
        return {};
      }
      if (this.userInfo.vipCorp) {
        if (this.userInfo.vipCorp.bookStyle == 1) {  //删除出差
          obj = obj.filter((item) => item.title != '出差');
          return obj;
        }
      } else {
        let userInfo = localget('userInfo');
        if (userInfo) {
          this.$store.commit('SET_USERINFO', userInfo);
          //如果是单订模式 删除申请单的入口
          if (userInfo.vipCorp && userInfo.vipCorp.bookStyle == 1) {
            obj = obj.filter((item) => item.title != '出差');
            return obj;
          }
        }
      }


      return obj
    }
  },
  async	created () {
    localStorage.setItem(AUTH_STATUS_KEY, 'authing')
    try {
      await this.auth()
    } finally {
      localStorage.setItem(AUTH_STATUS_KEY, "success")
    }
    this.hashAddr = this.$route.path
    this.topay = sessionStorage.getItem('AgentLeng')
    let message=  await  queryVipParameter('11605008') //消息
    let to_do=await  queryVipParameter('11605009') //待办
    let my=await  queryVipParameter('11605010') //我的
    this.taberr=[]
    message.value1==1 ? this.taberr.push('消息') : ''
    to_do.value1==1 ? this.taberr.push('待办') : ''
    my.value1==1 ? this.taberr.push('A007') : ''

  },
  watch: {
    '$route.path':{
      handler(val){
        if(isGat()){
          if(val=='/schedule'){
            this.dashboardshow=false
          }else{
            this.dashboardshow=true
          }
        }

        if(val === '/allorder'){//默认进入订单列表中的 未出行
          this.$store.commit('SET_ORDERLISTPARAMS', { findType: '3' })
        }
        if(val === '/allOrder'){
          this.hashAddr = '/allOrder?findType=1'
          return
        }
        this.hashAddr = val
      },
      deep:true,
      immediate:true
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.default-dashboard {
  .nav-tabbar {
    background-color: @color-background-white;
    // position: fixed;
    // left: 0px;
    // bottom: 0px;
    // right: 0px;
    width: 100%;
    height: 50px;
    // border-radius: @border-radius-sm;
    overflow: hidden;
    text-align: center;
    padding: 4px 0;
    line-height: 1;
	display: flex;
    justify-content: space-around;

    .normal {
      height: 26px;
    }

    .active {
      height: 26px;
    }

    @{deep}.van-badge--fixed {
      top: 6px;
    }
  }

}
</style>
